import { Organization } from './organization.models';
import { FreeRequestParams } from './shared.models';

export type Roles = {
  id: string;
  name: string;
  description: string;
  permissions: Permission[];
  organization: Organization;
  roles: string[];
  totalChildren?: number;
  totalAdministrators?: number;
  createdAt: string;
  updatedAt: string;
};

export enum Permission {
  CREATE_INVOICE = 'invoice:create',
  READ_STATISTICS_INVOICE = 'invoice:read_statistics',
  READ_INVOICE = 'invoice:read',
  EDIT_INVOICE = 'invoice:update',
  DELETE_INVOICE = 'invoice:delete',
  DOWNLOAD_INVOICE = 'invoice:download',
  CERTIFICATE_INVOICE = 'invoice:certificate',
  CANCELLATION_REQUEST_INVOICE = 'invoice:cancellation-request',
  CANCELLATION_APPROVE_INVOICE = 'invoice:cancellation-approve',
  CANCELLATION_REJECT_INVOICE = 'invoice:cancellation-reject',

  PAY_STICKER = 'sticker:pay',
  CREATE_STICKER = 'sticker:create',
  READ_STATISTICS_STICKER = 'sticker:read_statistics',
  READ_STICKER = 'sticker:read',
  EDIT_STICKER = 'sticker:update',
  DELETE_STICKER = 'sticker:delete',
  DOWNLOAD_RECEIPT_STICKER = 'sticker:download-receipt',

  CREATE_ORGANIZATION = 'organization:create',
  READ_STATISTICS_ORGANIZATION = 'organization:read_statistics',
  READ_ORGANIZATION = 'organization:read',
  EDIT_ORGANIZATION = 'organization:update',
  DELETE_ORGANIZATION = 'organization:delete',

  CREATE_REFERENCE_DATA = 'reference_data:create',
  READ_STATISTICS_REFERENCE_DATA = 'reference_data:read_statistics',
  READ_REFERENCE_DATA = 'reference_data:read',
  EDIT_REFERENCE_DATA = 'reference_data:update',
  DELETE_REFERENCE_DATA = 'reference_data:delete',

  READ_RECEIPT = 'receipt:read',
  READ_STATISTICS_RECEIPT = 'receipt:read_statistics',

  CREATE_UNIT_MEASURE = 'unit_measure:create',
  READ_UNIT_MEASURE = 'unit_measure:read',
  EDIT_UNIT_MEASURE = 'unit_measure:update',
  DELETE_UNIT_MEASURE = 'uni_measure:delete',

  CREATE_PRODUCT = 'product:create',
  READ_STATISTICS_PRODUCT = 'product:read_statistics',
  READ_PRODUCT = 'product:read',
  EDIT_PRODUCT = 'product:update',
  DELETE_PRODUCT = 'product:delete',

  CREATE_SALE_POINT = 'sale_point:create',
  READ_STATISTICS_SALE_POINT = 'sale_point:read_statistics',
  READ_SALE_POINT = 'sale_point:read',
  EDIT_SALE_POINT = 'sale_point:update',
  DELETE_SALE_POINT = 'sale_point:delete',

  CREATE_SALE_FORMAT = 'sale_format:create',
  READ_STATISTICS_SALE_FORMAT = 'sale_format:read_statistics',
  READ_SALE_FORMAT = 'sale_format:read',
  EDIT_SALE_FORMAT = 'sale_format:update',
  DELETE_SALE_FORMAT = 'sale_format:delete',

  CREATE_ESTABLISHMENT = 'establishment:create',
  READ_STATISTICS_ESTABLISHMENT = 'establishment:read_statistics',
  READ_ESTABLISHMENT = 'establishment:read',
  EDIT_ESTABLISHMENT = 'establishment:update',
  DELETE_ESTABLISHMENT = 'establishment:delete',

  CREATE_USER = 'user:create',
  READ_STATISTICS_USER = 'user:read_statistics',
  READ_USER = 'user:read',
  EDIT_USER = 'user:update',
  DELETE_USER = 'user:delete',

  CREATE_ORGANIZATION_USER = 'organization_user:create',
  READ_ORGANIZATION_USER = 'organization_user:read',
  EDIT_ORGANIZATION_USER = 'organization_user:update',
  DELETE_ORGANIZATION_USER = 'organization_user:delete',

  CREATE_PAYMENT = 'payment:create',
  READ_STATISTICS_PAYMENT = 'payment:read_statistics',
  READ_PAYMENT = 'payment:read',
  EDIT_PAYMENT = 'payment:update',
  DELETE_PAYMENT = 'payment:delete',

  CREATE_TAX = 'tax:create',
  READ_STATISTICS_TAX = 'tax:read_statistics',
  READ_TAX = 'tax:read',
  EDIT_TAX = 'tax:update',
  DELETE_TAX = 'tax:delete',

  CREATE_TAX_TYPE = 'tax_type:create',
  READ_TAX_TYPE = 'tax_type:read',
  EDIT_TAX_TYPE = 'tax_type:update',
  DELETE_TAX_TYPE = 'tax_type:delete',

  CREATE_CUSTOMER_SUPPLIER = 'customer_supplier:create',
  READ_STATISTICS_CUSTOMER_SUPPLIER = 'customer_supplier:read_statistics',
  READ_CUSTOMER_SUPPLIER = 'customer_supplier:read',
  EDIT_CUSTOMER_SUPPLIER = 'customer_supplier:update',
  DELETE_CUSTOMER_SUPPLIER = 'customer_supplier:delete',

  READ_AUDIT_LOG = 'audit_log:read',
  READ_NOTIFICATION = 'notification:read',

  CREATE_ROLE = 'role:create',
  READ_ROLE = 'role:read',
  EDIT_ROLE = 'role:update',
  DELETE_ROLE = 'role:delete',

  READ_IMPORT_TASK = 'import_task:read',

  CREATE_TASK = 'task:create',
  READ_TASK = 'task:read',
  EDIT_TASK = 'task:update',
  DELETE_TASK = 'task:delete',

  CREATE_TAX_RULE = 'tax_rule:create',
  READ_TAX_RULE = 'tax_rule:read',
  EDIT_TAX_RULE = 'tax_rule:update',
  DELETE_TAX_RULE = 'tax_rule:delete',

  READ_ORGANIZATION_PREFERENCE = 'organization_preference:read',
  EDIT_ORGANIZATION_PREFERENCE = 'organization_preference:update',

  READ_CURRENCY = 'currency:read',
  EDIT_CURRENCY = 'currency:update',
  DELETE_CURRENCY = 'currency:delete',
  CREATE_CURRENCY = 'currency:create',
  DECLARE_NEW_VALUE_CURRENCY = 'currency:declare-new-value',
  READ_CURRENCY_HISTORY = 'currency:read-history',

  CREATE_BILLING_EQUIPMENTS = 'billing_equipments:create',
  READ_STATISTICS_BILLING_EQUIPMENTS = 'billing_equipments:read_statistics',
  READ_BILLING_EQUIPMENTS = 'billing_equipments:read',
  EDIT_BILLING_EQUIPMENTS = 'billing_equipments:update',
  DELETE_BILLING_EQUIPMENTS = 'billing_equipments:delete',

  CREATE_DGI_ADMIN = 'admin_user:create',
  READ_DGI_ADMIN = 'admin_user:read',
  EDIT_DGI_ADMIN = 'admin_user:update',
  DELETE_DGI_ADMIN = 'admin_user:delete',

  CREATE_DGI_DASHBOARD_CONFIG = 'dgi_dashboard:create',
  READ_DGI_DASHBOARD_CONFIG = 'dgi_dashboard:read',
  EDIT_DGI_DASHBOARD_CONFIG = 'dgi_dashboard:update',
  DELETE_DGI_DASHBOARD_CONFIG = 'dgi_dashboard:delete',

  READ_DGI_SECURITY_CONFIG = 'dgi_security:read',
  EDIT_DGI_SECURITY_CONFIG = 'dgi_security:update',

  CREATE_STICKER_CONSUMPTION = 'sticker_consumption:create',
  READ_STICKER_CONSUMPTION = 'sticker_consumption:read',
  EDIT_STICKER_CONSUMPTION = 'sticker_consumption:update',
  DELETE_STICKER_CONSUMPTION = 'sticker_consumption:delete',

  CREATE_TAX_PROFILE = 'tax_profile:create',
  READ_TAX_PROFILE = 'tax_profile:read',
  EDIT_TAX_PROFILE = 'tax_profile:update',
  DELETE_TAX_PROFILE = 'tax_profile:delete',

  CREATE_TERNES = 'ternes:create',
  READ_TERNES = 'ternes:read',
  EDIT_TERNES = 'ternes:update',
  DELETE_TERNES = 'ternes:delete',

  CREATE_API_KEY = 'api_key:create',
  READ_API_KEY = 'api_key:read',
  DELETE_API_KEY = 'api_key:delete'
}

export type RolesListParams = FreeRequestParams & {
  name: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
};

export type RolesCreationParams = {
  name: string;
  organizationId: string;
  roles?: string[] | string;
  description?: string;
  permissions?: string[];
};

export enum Role {
  ADMIN = 'ROLE_ADMIN',
  SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ORGANIZATION_USER = 'ROLE_ORGANIZATION',
  ORGANIZATION_ADMIN = 'ROLE_ORGANIZATION_ADMIN',
  ROLE_USER = 'ROLE_USER'
}
